import React from 'react';
import { motion } from 'framer-motion';

interface PageWrapperProps {
  children: React.ReactNode;
  titulo?: string;
  descricao?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children, titulo, descricao }) => {
  const pageContentVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { delay: 0.2, duration: 0.5 } },
  };

  const descriptionVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0, transition: { delay: 0.4, duration: 0.5 } },
  };

  return (
    <div className="min-h-screen w-full bg-background text-[#f2eee3] flex flex-col items-center justify-start py-4 border border-primary/20 rounded-lg">
      <motion.div
        className="w-full mx-auto p-2 sm:p-2 lg:p-4"
        initial="hidden"
        animate="visible"
        variants={pageContentVariants}
      >
        {titulo && (
          <motion.h1
            className="text-4xl md:text-5xl font-extrabold text-[#d9a526] mb-2 md:mb-4 tracking-tight text-center"
            variants={titleVariants}
          >
            {titulo}
          </motion.h1>
        )}
        {descricao && (
          <motion.p
            className="text-lg md:text-xl text-[#e8c97d] mb-6 md:mb-8 text-center max-w-3xl mx-auto"
            variants={descriptionVariants}
          >
            {descricao}
          </motion.p>
        )}
        <div className="rounded-lg shadow-2xl w-full">
          {children}
        </div>
      </motion.div>
    </div>
  );
};

export default PageWrapper;